import useEditCharacterCharacteristic from '../composables/useEditCharacterCharacteristic'
//------------------------------------------
// update character characteristics harness
//------------------------------------------
export default async function useUpdateCharacterCharacteristicsHarness(changed_chars) {
  console.log('------------------------')
  console.log('IN useUpdateCharacterCharacteristicsHarness')
  console.log('!!!!!! XXXX changed_chars:', changed_chars)
  //-----------------------------------------------------------------------------------
  // create promise for each characteristic update (update calls executed in parallel)
  //-----------------------------------------------------------------------------------
  const promises = changed_chars.map((e) => useEditCharacterCharacteristic(e))
  //----------------------------------------------------------------------------
  // returns single promise once all updates complete - let errors propagate up
  //----------------------------------------------------------------------------
  return Promise.all(promises)
}
